import classes from './../Certificate.module.css';
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { Button, Col, FloatingLabel, Form, Row } from 'react-bootstrap';
import { LoadScreenMin } from '../../UI/LoadScreenMin';
import { useTranslation } from 'react-i18next';
import { InputPhone } from './InputPhone';
import { useDispatch, useSelector } from 'react-redux';
import { Token } from '../../../interface/Token';
import { useTokenTP } from '../../../features/useTokenTP';
import { IPerson } from '../../../interface/IPerson';
import { usePostCertificateMutation, usePostOrderBankLinkMutation, usePostOrderItemMutation, usePostOrderMutation, usePostSetOrderStatusMutation, usePutPersonMutation } from '../../../features/CallTPApi';
import { ICertificate } from '../../../interface/ICertificate';
import { setAlertMsgStore } from '../../../features/alertMsgSlisce';
import { IOrderItems } from '../../../interface/IOrderItem';


export const CertForm = () => {
    const { register, handleSubmit, formState: { errors }, reset, setValue, setError } = useForm<any>();
    const [t] = useTranslation("global");
    const token = useSelector((state: any) => state.tokenTP?.value) as Token;
    const { logOutTP } = useTokenTP()
    const dispatch = useDispatch()
    // const [createCertificateOrder, { isLoading: isLoading }] = useCreateCertificateOrderMutation();
    const [amount, setAmount] = useState<any>(null);
    const [amountError, setAmountError] = useState<any>(null);
    const [postError, setPostError] = useState();
    const [disabledForm, setDisabledForm] = useState<boolean>(false)
    const whoami = useSelector((state: any) => state.whoamiTP) as IPerson
    const [postOrder, { isLoading: isPostOrder }] = usePostOrderMutation()
    const [postOrderItem, { isLoading: isPostItem }] = usePostOrderItemMutation()
    const [postCertificate, { isLoading: isPostCert }] = usePostCertificateMutation()
    const [postOrderBankLink, { isLoading: isGetingBankLink }] = usePostOrderBankLinkMutation()
    const [putPerson, { isLoading: isPutPerson }] = usePutPersonMutation()
    const [postSetOrderStatus, { isLoading: isPostOrderStatus }] = usePostSetOrderStatusMutation()
    const createOrder = async ({ newOrder, data }: any) => {
        await postOrder(newOrder).then((r: any) => {
            // console.log(r)
            if (!r.error) {
                console.log(r)
                localStorage.setItem('order', JSON.stringify(r.data))
                const orderId = r.data.id
                postCertificate({
                    // certificateNumber: data.certificateNumber,
                    personId: whoami.id,
                    amount: data.amount,
                    // pinCode: generatePinCode()
                } as ICertificate).then((r: any) => {
                    if (!r.error) {
                        console.log(r)
                    }
                    if (r.error) {
                        console.log(r.error)
                        const error = r.error as any
                        dispatch(setAlertMsgStore({
                            title: error.data ?? "Ошибка формирования сертификата в заказе",
                            variant: "danger"
                        } as any))
                        return;
                    }
                    const newBasketItem = {
                        fiscalData: '',
                        orderId: orderId,
                        quantity: 1,
                        certificateId: r.data.id
                    } as IOrderItems

                    postOrderItem(newBasketItem).then((r: any) => {
                        if (!r.error) {
                            postSetOrderStatus({
                                id: orderId,
                                status: {
                                    orderStatus: 1,
                                    clientId: data.id,
                                }
                            }).then((r: any) => {
                                if (!r.error) {
                                    postOrderBankLink({
                                        id: orderId,
                                        approveURL: `https://${window.location.host}/about-project/certificates/paystatus`,
                                        cancelURL: `https://${window.location.host}/about-project/certificates/paystatus`,
                                        declineURL: `https://${window.location.host}/about-project/certificates/paystatus`
                                    }).then((r: any) => {
                                        if (!r.error) {
                                            reset()
                                            const dataLink = JSON.parse(r.data as string) as any

                                            window.location.href = dataLink.bankLink as string
                                        }
                                        else {
                                            dispatch(setAlertMsgStore({ title: `Ошибка!`, variant: 'danger' } as any))
                                            // setIsLoadingBank(false)
                                        }
                                    })
                                }
                            })
                        }
                    })
                })
            }
            if (r.error) {
                dispatch(setAlertMsgStore({
                    title: r.error.data ?? "Ошибка создания заказа",
                    variant: "danger"
                } as any))
            }
        })
    }

    const submitForm = async (data: any) => {
        console.log(amount)
        console.log(disabledForm)
        if (!amount) {
            setAmountError('Выберите номинал')
            setError("amount",
                {
                    type: "manual",
                    message: t("Выберите номинал"),
                }
            )

        }
        else {


            const body = {
                amount: amount,
                firstName: data.firstName,
                lastName: data.lastName,
                email: data.email,
                phone: data.phone
            }
            const jsonBody = JSON.stringify(body)
            const newOrder = {
                orderNumber: '',
                clientId: whoami.id
            }

            if (disabledForm) {
                console.log("не обновляем данные покупателя")
                createOrder({ newOrder, data })
            } else {
                console.log("обновляем данные покупателя")
                const personNewData = {
                    id: data.id,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    eMail: data.eMail,
                    phone: '+' + data.phone.replace(/\D+/g, ""),
                } as IPerson;
                await putPerson(personNewData).then(async (res: any) => {
                    console.log(!res.error)
                    if (!res.error) {
                        createOrder({ newOrder, data })
                    }
                    else {
                        dispatch(setAlertMsgStore({ title: `Ошибка обновления данных покупателя.`, variant: 'danger' } as any))
                    }
                })
            }
            return
        }
    }

    useEffect(() => {
        if (amount) {
            setAmountError(null)
            setValue("amount", amount)
            // setError("amount", null)
        }
    }, [amount])

    useEffect(() => {
        if (whoami) {
            console.log(disabledForm)
            setValue('id', whoami.id)
            setValue('phone', whoami.phone)
            setValue('firstName', whoami.firstName)
            setValue('lastName', whoami.lastName)
            setValue('eMail', whoami.eMail)
            // setNewStatus()

            if (whoami.firstName && whoami.lastName && whoami.eMail) {
                setDisabledForm(true)
                console.log(true)
            }
        }
    }, [whoami])

    const amountData = [
        {
            id: 1,
            defaultValue: 8000,
            text: '8 000'
        },
        {
            id: 2,
            defaultValue: 10000,
            text: '10 000'
        },
        {
            id: 3,
            defaultValue: 12000,
            text: '12 000'
        },
        {
            id: 4,
            defaultValue: 14000,
            text: '14 000'
        },
        {
            id: 5,
            defaultValue: 16000,
            text: '16 000'
        }
    ]
    const agreementLable = () => {
        return (
            <label className="form-check-label" style={{ fontSize: '12px' }}><a href='https://leningradcenter.ru/api/redirecturls/privacy-policy' target={"_blank"} >{t("form.agreement")}</a></label>
        )
    }
    const praviloLable = () => {
        return (
            <label className="form-check-label" style={{ fontSize: '12px' }}><a href='https://leningradcenter.ru/api/redirecturls/public-offer-certificates' target={"_blank"} >{t("form.giftRules")}</a></label>
        )
    }
    return (
        <div>
            {(isPostOrder || isPostItem || isPostCert || isGetingBankLink || isPutPerson || isPostOrderStatus) ? <LoadScreenMin /> :
                <Row>
                    <Col md={6} className='mb-2'>
                        <div className="justify-content-center">
                            <div>
                                <h6 className="h-cert">{t("form.selValueCert")}</h6>
                                {errors.amount && (
                                    <span className="text-danger fs-4">
                                        {errors.amount?.message as any}
                                    </span>
                                )}

                                <div className='d-flex flex-wrap justify-content-center gap-3'>
                                    {amountData.map(amount =>
                                        <div key={amount.id}>
                                            <div>
                                                <div id={`CardBox${amount.id}`} className={classes.lcCartSelectBox}>
                                                    <div className={classes.lcCartSelectBoxContent}>
                                                        <input type="radio"
                                                            {...register("amount", { required: { value: true, message: "Выберите номинал" } })}
                                                            id={`box${amount.id}`} name="Amount" defaultValue={amount.defaultValue} onClick={(e: any) => {
                                                                setAmount(e.target.value)
                                                            }} />
                                                        <label className={`${classes.lcCardImg} ${classes.lcCartSelectLabel}`} htmlFor={`box${amount.id}`}>{amount.text} ₽</label>
                                                        <div className="check"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>
                    </Col>
                    <Col md={6} className='d-grid mb-2'>
                        <div className="h-cert" style={{ fontSize: "2rem" }}><b>{t("form.cetFormTitle")}</b></div>
                        {!whoami?.id ?
                            <div>
                                <div className='pe-lg-5 ps-lg-5'>
                                    <InputPhone />
                                </div>
                            </div>
                            :
                            <Form onSubmit={handleSubmit(submitForm)} className=''>
                                <div className='d-grid gap-1'>
                                    <div style={{ fontSize: "12px" }}>
                                        Чтобы купить билет на это событие, заполните анкету. Информация о вас будет доступна только организаторам этого события.
                                    </div >
                                    <FloatingLabel label="Телефон">
                                        <Form.Control placeholder="Телефон" disabled={true} {...register('phone')} />
                                    </FloatingLabel>
                                    <FloatingLabel label="Имя">
                                        <Form.Control placeholder="Имя" isInvalid={errors?.firstName ? true : false} disabled={disabledForm} {...register('firstName', { required: true })} />
                                    </FloatingLabel>
                                    <FloatingLabel label="Фамилия">
                                        <Form.Control placeholder="Фамилия" isInvalid={errors?.lastName ? true : false} disabled={disabledForm}  {...register('lastName', { required: true })} />
                                    </FloatingLabel>
                                    <FloatingLabel label="E-mail">
                                        <Form.Control placeholder="E-mail" isInvalid={errors?.eMail ? true : false} disabled={disabledForm}  {...register('eMail', {
                                            required: true, pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                message: "invalid email address"
                                            }
                                        })} />
                                    </FloatingLabel>
                                    {disabledForm &&
                                        <Button variant="light" onClick={() => { setDisabledForm(false) }} size="sm">Изменить данные</Button>
                                    }
                                    <Button variant="link" size='sm' onClick={() => {
                                         logOutTP() 
                                    }}>Выйти из профиля</Button>
                                    <div>
                                        <div className="d-flex">
                                            <Form.Switch label={agreementLable()}
                                                className="check-input-lc"
                                                isInvalid={errors.policy?.message !== undefined}
                                                {...register("policy",
                                                    { required: { value: true, message: "Необходимо согласие на обработку персональных данных" } }
                                                )} />
                                        </div>
                                        <div className="d-flex">
                                            <Form.Switch label={praviloLable()}
                                                className="check-input-lc"
                                                color='dark'
                                                isInvalid={errors.pravilo?.message !== undefined}
                                                {...register("pravilo", { required: { value: true, message: "Необходимо согласие c правилами обращения подарочных сертификатов" } })}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <div className=" form-check form-switch">
                                                <label className="form-check-label " style={{ fontSize: "12px" }}>{t("form.receiveNewsletter")}</label>
                                                <input type="checkbox" className="form-check-input check-input-lc" {...register("receiveNewsletter", {})} />
                                            </div>
                                            <div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='d-flex'>
                                        <input type={'submit'} value={t("form.confirm")} className='btn btn-lc btn-lc-cert w-auto flex-fill' />
                                    </div>
                                </div>
                            </Form>
                        }
                    </Col>
                </Row>


            }
        </div>
    )
}